var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle text-danger"}),_vm._v(" UNDER CONSTRUCTION\n\t")])])}]

export { render, staticRenderFns }